import { Component, PropsWithChildren } from 'react';
import { DataGridPanel } from './DataGridPanel';
import { IMultiProps } from './types';

export class MultiSelectPanel<T> extends Component<IMultiProps<T>, {}> {
  public render() {
    return DataGridPanel.multi<T>(this.props);
  }
}

export default MultiSelectPanel;
